import React from "react";

export default function ValentineFrame9({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 2000 2000"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls9-1{fill:#ff97c1}.cls9-2{fill:#9a1663}.cls9-3{fill:#e0144c}.cls9-4{fill:#ff5858}"
            }
          </style>
        </defs>
        <path
          className="cls9-1"
          d="M503.81 1426.4h8v165h-8zM754.72 1427.34h8v165h-8zM926.17 1427.34h8v204.83h-8zM1215.36 1426.4h8v204.83h-8zM1433.98 1438.41h8v244.89h-8zM1622.46 1414.92h8v244.89h-8z"
        />
        <path
          className="cls9-2"
          d="M808.1 1535.44c-2.64-7.11-10.36-16-21.3-18-9.76-1.83-20.18 2.14-28.08 10.24-7.9-8.1-18.32-12.07-28.08-10.24-10.94 2-18.66 10.92-21.3 18-6.93 18.62 12.54 47.84 49.35 71.49h.06c36.81-23.65 56.25-52.87 49.35-71.49Z"
        />
        <path
          className="cls9-3"
          d="M1325.94 1549.71c-5.7-15.34-22.36-34.5-46-38.92-21.06-4-43.56 4.62-60.61 22.11-17-17.49-39.55-26.06-60.61-22.11-23.6 4.42-40.26 23.58-46 38.92-15 40.2 27.06 103.26 106.51 154.31h.14c79.52-51.02 121.53-114.11 106.57-154.31Z"
        />
        <path
          className="cls9-4"
          d="M1708.17 1547.53c-4.38-11.76-17.15-26.45-35.24-29.84-16.15-3-33.4 3.54-46.47 17-13.06-13.41-30.31-20-46.46-17-18.09 3.39-30.86 18.08-35.24 29.84-11.46 30.81 20.74 79.16 81.65 118.29h.11c60.91-39.13 93.11-87.48 81.65-118.29ZM1002.27 1627.79c-3.86-10.37-15.13-23.34-31.1-26.33-14.25-2.66-29.47 3.13-41 15-11.53-11.83-26.75-17.62-41-15-16 3-27.24 16-31.1 26.33-10.11 27.2 18.31 69.85 72 104.39h.1c53.83-34.54 82.22-77.18 72.1-104.39Z"
        />
        <path
          className="cls9-3"
          d="M603.64 1609.34c-.1 1.14-.24 2.28-.42 3.43a76 76 0 0 1-4.83 17.13c-.47 1.17-1 2.35-1.5 3.53q-1.92 4.3-4.38 8.71a153.61 153.61 0 0 1-13.73 20.44q-3.84 4.9-8.25 9.83c-1.33 1.49-2.7 3-4.12 4.48a218.38 218.38 0 0 1-5.44 5.6q-5.1 5.07-10.75 10.11t-12 10.14a355.06 355.06 0 0 1-30.35 21.78h-.13c-10.18-6.55-19.67-13.32-28.39-20.22q-6-4.72-11.48-9.52t-10.42-9.55q-4.95-4.79-9.4-9.58-5.78-6.2-10.67-12.39-2.94-3.69-5.55-7.36c-1-1.36-1.89-2.7-2.79-4.05a129.28 129.28 0 0 1-9.76-17.21c-.2-.42-.39-.84-.56-1.25a85.13 85.13 0 0 1-5.36-15.59 61.78 61.78 0 0 1-1.48-9.68 50 50 0 0 1 .12-8.12 41.72 41.72 0 0 1 2.42-10.75c.31-.83.66-1.68 1-2.54a55.64 55.64 0 0 1 10.11-15c7.2-7.77 17.15-14.36 29.15-16.6 18.46-3.46 38.19 4.05 53.13 19.38 14.95-15.33 34.68-22.84 53.14-19.38 13.81 2.58 24.92 10.93 32.25 20.2a56.12 56.12 0 0 1 5 7.43 47.37 47.37 0 0 1 3 6.49c.46 1.23.85 2.48 1.19 3.76a46.88 46.88 0 0 1 1.25 16.35Z"
        />
        <path
          className="cls9-2"
          d="M1503 1682.16c0 .8 0 1.61-.08 2.43a45.48 45.48 0 0 1-2.32 11.36 74.4 74.4 0 0 1-7.66 15.86q-1.89 3-4.11 6.1c-.69.94-1.4 1.89-2.14 2.84-1.81 2.36-3.78 4.74-5.89 7.11q-4.2 4.74-9.14 9.48-5.42 5.21-11.7 10.33c-1.94 1.59-4 3.17-6 4.74-5 3.78-10.28 7.5-15.91 11.11h-.09c-5.62-3.61-10.93-7.33-15.9-11.11-2.07-1.57-4.07-3.15-6-4.74q-6.27-5.12-11.69-10.33-4.93-4.72-9.14-9.48c-2.11-2.37-4.08-4.75-5.9-7.11-.74-1-1.45-1.9-2.13-2.84q-2.24-3.08-4.12-6.1a75.37 75.37 0 0 1-7.66-15.86 45.48 45.48 0 0 1-2.32-11.36c0-.81-.08-1.62-.08-2.43a29.71 29.71 0 0 1 1.42-9.16c.11-.34.23-.69.36-1a32.93 32.93 0 0 1 3.11-6.15c4.77-7.48 13.21-14.88 24.16-16.94 12.49-2.34 25.84 2.74 36 13.12 10.11-10.38 23.46-15.46 36-13.12 11 2.06 19.39 9.46 24.17 16.94a32.93 32.93 0 0 1 3.11 6.15c.13.34.25.68.36 1a29.62 29.62 0 0 1 1.29 9.16Z"
        />
        <path
          className="cls9-1"
          d="M1584.16 1443.38H538.05a71.9 71.9 0 0 1-71.81-71.81V325.46a71.9 71.9 0 0 1 71.81-71.82h1046.11a71.89 71.89 0 0 1 71.84 71.82v1046.11a71.89 71.89 0 0 1-71.84 71.81ZM538.05 273.64a51.87 51.87 0 0 0-51.81 51.82v1046.11a51.87 51.87 0 0 0 51.81 51.81h1046.11a51.87 51.87 0 0 0 51.81-51.81V325.46a51.87 51.87 0 0 0-51.81-51.82ZM1501.57 1673h-127.18c.11-.34.23-.69.36-1a32.93 32.93 0 0 1 3.11-6.15h120.24a32.93 32.93 0 0 1 3.11 6.15c.13.31.25.65.36 1ZM1503 1682.16c0 .8 0 1.61-.08 2.43h-129.87c0-.81-.08-1.62-.08-2.43ZM1500.58 1696a74.4 74.4 0 0 1-7.66 15.86H1383a75.37 75.37 0 0 1-7.66-15.86ZM1488.81 1717.91c-.69.94-1.4 1.89-2.14 2.84h-97.39c-.74-1-1.45-1.9-2.13-2.84ZM1480.78 1727.86q-4.2 4.74-9.14 9.48h-67.32q-4.93-4.72-9.14-9.48ZM1459.94 1747.67c-1.94 1.59-4 3.17-6 4.74H1422c-2.07-1.57-4.07-3.15-6-4.74ZM602.44 1593a46.88 46.88 0 0 1 1.2 16.34l-106.57-12.82-31.65-3.8-50-6a55.64 55.64 0 0 1 10.11-15l103.07 12.4 31.65 3.8ZM413.37 1617.8l189.85-5a76 76 0 0 1-4.83 17.13l-173.62 4.6-5.48.14c-.2-.42-.39-.84-.56-1.25a85.13 85.13 0 0 1-5.36-15.62Z"
        />
        <path
          className="cls9-4"
          d="m598.22 1582.75-38 5.17-63.18 8.6-85.18 11.6a50 50 0 0 1 .14-8.12l53.46-7.27 63.18-8.6 64.6-8.8a56.12 56.12 0 0 1 4.98 7.42Z"
        />
        <path
          className="cls9-1"
          d="m495 1647.3 101.89-13.87q-1.92 4.3-4.38 8.71l-72 9.81-52 7.08-31.06 4.23q-2.94-3.69-5.55-7.36l11.12-1.52Z"
        />
        <path
          className="cls9-4"
          d="m520.49 1652 58.29 10.63q-3.84 4.9-8.25 9.83c-1.33 1.49-2.7 3-4.12 4.48l-21-3.82-77-14-25.41-4.74-13.91-2.53a129.28 129.28 0 0 1-9.76-17.21c-.2-.42-.39-.84-.56-1.25l6 1.11 70.23 12.8Z"
        />
        <path
          className="cls9-1"
          d="m545.45 1673.07 25.08-.66c-1.33 1.49-2.7 3-4.12 4.48a218.38 218.38 0 0 1-5.44 5.6l-103.51 2.74q-4.95-4.79-9.4-9.58Z"
        />
        <path
          className="cls9-4"
          d="m467.88 1694.78 82.34-2.18q-5.72 5.1-12 10.14l-58.87 1.56q-5.97-4.72-11.47-9.52Z"
        />
        {children}
      </g>
    </svg>
  );
}
